import { oneLoginRedirect } from 'utils/redirects';

export const TAXI_REST_API_ROOT = '/api/v1';

class NetworkError extends Error {
  constructor(responseStatus, response) {
    super();
    this.status = responseStatus;
    this.response = response;
  }
}

export function status(response) {
  if (response.status === 403) {
    return oneLoginRedirect();
  }
  if (response.status >= 400) {
    throw new NetworkError(response.status, response);
  }
  return response;
}

function extractJSON(response) {
  return response.json();
}

export function fetchUrl(url) {
  const headers = new Headers({
    Accept: 'application/json',
    'Content-Type': 'application/json',
  });
  return fetch(url, {
    credentials: 'same-origin',
    headers,
  }).then(status).then(extractJSON);
}

export function postUrl(url, body) {
  return fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }).then(status)
    .then(extractJSON);
}

export function deleteUrl(url) {
  return fetch(url, {
    method: 'DELETE',
    credentials: 'same-origin',
  }).then(status);
}

export function publishForm(id) {
  return postUrl(`${TAXI_REST_API_ROOT}/publish/${id}`, {});
}

export function unpublishForm(id) {
  return deleteUrl(`${TAXI_REST_API_ROOT}/publish/${id}`);
}

export function checkAuthorization() {
  return fetchUrl(`${TAXI_REST_API_ROOT}/isAuthorized`);
}

export function getRuntimeConfig() {
  return fetchUrl(`${TAXI_REST_API_ROOT}/runtimeConfig`);
}
